import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";

import { UserRole } from "../../enums";
import { convertTokenJWT } from "../../utilities";

import { EventsRoles, LearningCenter, ReportsRoles } from "src/assets/config/config";

export const roleGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  const roleCode = convertTokenJWT()?.RoleCode;
  if (!roleCode) {
    localStorage.clear();
    router.navigate(["/"]);
    return false;
  }

  let permissionsRoute = route;
  let permissions: UserRole[] = [];

  while (permissionsRoute) {
    if (permissionsRoute.data["permissions"]) {
      permissions = permissionsRoute.data["permissions"];
      break;
    }

    permissionsRoute = permissionsRoute.parent!;
  }

  if (permissions.includes(roleCode)) return true;

  if (!permissions) {
    router.navigateByUrl("/error/403");
    throw new Error("There's no permissions");
  }

  if ([UserRole.CUSTOMER].includes(roleCode)) {
    router.navigate(["/services"]);
    return true;
  } else if (roleCode.includes(UserRole.KIOSK)) {
    router.navigate(["/kiosk"]);
    return true;
  } else if (
    UserRole.COUNTER === roleCode ||
    EventsRoles.includes(roleCode) ||
    LearningCenter.includes(roleCode) ||
    [UserRole.MUSEUMFRIENDSDEPARTMENT].includes(roleCode)
  ) {
    router.navigate(["/admin/calendar"]);
    return true;
  } else if (ReportsRoles.includes(roleCode)) {
    router.navigate(["/admin/reports"]);
    return true;
  } else {
    // permission of the `services` route.
    if (permissions.includes(UserRole.CUSTOMER)) {
      router.navigate(["/admin"]);
      return true;
    }
  }

  router.navigateByUrl("/error/403");
  return false;
};
